'use client';

import React from 'react';
import { MessageSquare, Clock, ArrowUpRight } from 'lucide-react';

// Backend integration: GET /api/seller/messages?limit=6&unread=true
const messages = [
  {
    id: 'msg-001',
    customer: 'Bilal Hussain',
    initials: 'BH',
    avatarColor: 'bg-blue-500',
    product: 'Samsung Galaxy A55',
    preview: 'Is this phone compatible with 5G in Pakistan?',
    time: '12 min ago',
    unread: true,
    type: 'question' as const,
  },
  {
    id: 'msg-002',
    customer: 'Sana Iqbal',
    initials: 'SI',
    avatarColor: 'bg-pink-500',
    product: 'Haier 1.5 Ton AC',
    preview: 'When will my order be delivered? I ordered 3 days ago.',
    time: '45 min ago',
    unread: true,
    type: 'complaint' as const,
  },
  {
    id: 'msg-003',
    customer: 'Hassan Mirza',
    initials: 'HM',
    avatarColor: 'bg-green-500',
    product: 'Sony WH-1000XM5',
    preview: 'Do you have this in white color variant?',
    time: '2h ago',
    unread: true,
    type: 'question' as const,
  },
  {
    id: 'msg-004',
    customer: 'Ayesha Raza',
    initials: 'AR',
    avatarColor: 'bg-purple-500',
    product: 'Logitech MX Master 3S',
    preview: 'The package arrived but one item was missing.',
    time: '3h ago',
    unread: false,
    type: 'complaint' as const,
  },
  {
    id: 'msg-005',
    customer: 'Kamran Shah',
    initials: 'KS',
    avatarColor: 'bg-orange-500',
    product: 'HP Victus 15 Laptop',
    preview: 'Can I get an invoice for this purchase for tax purposes?',
    time: '5h ago',
    unread: false,
    type: 'question' as const,
  },
  {
    id: 'msg-006',
    customer: 'Nadia Farooq',
    initials: 'NF',
    avatarColor: 'bg-teal-500',
    product: 'Canon EOS M50 II',
    preview: 'Thank you for the fast delivery! Great product.',
    time: '7h ago',
    unread: false,
    type: 'positive' as const,
  },
];

const typeConfig = {
  question: { dot: 'bg-blue-400', label: 'Q&A' },
  complaint: { dot: 'bg-danger', label: 'Complaint' },
  positive: { dot: 'bg-success', label: 'Positive' },
};

export default function RecentMessages() {
  const unreadCount = messages.filter((m) => m.unread).length;

  return (
    <div className="card p-5 h-full flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <MessageSquare size={16} className="text-primary" />
          <h2 className="text-base font-semibold">Customer Messages</h2>
          {unreadCount > 0 && (
            <span className="badge-danger">{unreadCount} unread</span>
          )}
        </div>
        <button className="text-xs text-primary font-semibold hover:underline flex items-center gap-1">
          Open Chat <ArrowUpRight size={12} />
        </button>
      </div>

      <div className="space-y-2 flex-1">
        {messages.map((msg) => (
          <div
            key={msg.id}
            className={`flex gap-3 p-2.5 rounded-lg cursor-pointer transition-colors hover:bg-muted/60 ${
              msg.unread ? 'bg-secondary/40' : ''
            }`}
          >
            {/* Avatar */}
            <div className={`w-8 h-8 rounded-full ${msg.avatarColor} flex items-center justify-center text-white text-xs font-bold shrink-0`}>
              {msg.initials}
            </div>

            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-1">
                <div>
                  <p className="text-xs font-semibold text-foreground">{msg.customer}</p>
                  <p className="text-2xs text-muted-foreground truncate">{msg.product}</p>
                </div>
                <div className="flex items-center gap-1 shrink-0">
                  {msg.unread && (
                    <span className="w-2 h-2 rounded-full bg-primary" />
                  )}
                  <span className="text-2xs text-muted-foreground whitespace-nowrap">{msg.time}</span>
                </div>
              </div>
              <p className="text-xs text-muted-foreground mt-1 line-clamp-1">{msg.preview}</p>

              <div className="flex items-center justify-between mt-1.5">
                <div className="flex items-center gap-1">
                  <span className={`w-1.5 h-1.5 rounded-full ${typeConfig[msg.type].dot}`} />
                  <span className="text-2xs text-muted-foreground">{typeConfig[msg.type].label}</span>
                </div>
                <button className="text-2xs text-primary font-semibold hover:underline">
                  Reply
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-3 pt-3 border-t border-border">
        <div className="flex items-center gap-1.5 text-xs text-warning">
          <Clock size={12} />
          <span>Avg response time: 18h — target &lt;24h</span>
        </div>
      </div>
    </div>
  );
}